<template>
  
      <div class="col-md-12 col-sm-12 page-tools-container-bar animate-box " >
          <div class="archives"  >

            <div>
              <a :href="CONTENT_DOMAIN+'/new_eesite_direct_print_page.php?id_cr='+content_id" target="_blank" v-html="'Print'"></a>  |
                          
              <div class="email-tools">
                <form method="post" action="" id="frmemail">
                
                <label for="toemail" v-html="'Email to'"></label>
                <input type="email" ref="toEmail" name="toemail" id="toemail" v-model="to_email" required="">
                <label for="fromemail" style="padding-left:3px;" v-html="'Email from'"></label>
                <input type="email" name="fromemail" id="fromemail" v-model="from_email" required="">
                
                <input type="button" name="submit" :value="'Send PDF'" @click="sendpdf()" class="button small">
                
                </form>
              </div>	
              <label v-html="returnmsg" role="alert" style="color:green;"></label><br/>
              <span class="pageTools">Link(s) may open a new browser window. Close window to return to this page.		</span> 
            </div>


          </div>
          
      </div>
  
</template>

<script>
import axios from 'axios';
  
export default {
    name: 'PageTools',
    data() {
      return {
        CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
        FORM_ACTION_DOMAIN:this.$store.state.FORM_ACTION_DOMAIN,
        to_email:'',
        from_email:'',
        msg1:'',
        msg2:'',
        logo1:'',
        logo2:'',
        content_id:this.$route.params.id,
        returnmsg:''
      
      };                
    },  
    components:{
        
    },
    mounted :function(){
      
      
    },
    
    methods:{
        sendpdf(){
          
          const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'                   
                }
            }
            const formData = new FormData()
            formData.append('toemail', this.to_email)
            formData.append('fromemail', this.from_email)
            formData.append('id_cr', this.content_id)
            formData.append('logo1', this.logo1) // need to get from 
            formData.append('logo2', this.logo2)
            formData.append('msg1', this.msg1)
            formData.append('msg2', this.msg2)
          
           
            axios.post(this.FORM_ACTION_DOMAIN+'/new_eesite_forms/send_pdf_content_direct.php',formData,config)
            .then(response => {
               
                if(response === undefined || response.length == 0 ){
                    this.returnmsg='! Something went wrong, Please try again'
                }
                else{
                  this.returnmsg = response.data
                  this.to_email=''
                  this.from_email=''
                  
                  if(this.returnmsg=='All fields are required'){
                    this.$refs.toEmail.focus();
                  }
                    
                }
                
            })
            .catch(() => {                
                this.returnmsg='Try after sometime'
            });

        },
     

        loadExternalScript(path_to_file){
            
            const plugin = document.createElement("script");
            plugin.setAttribute(
            "src",
            path_to_file
            );
            plugin.async = true;
            document.body.appendChild(plugin);
        }
      }
}
</script>

<style scoped>
.page-tools-container-bar{
    
    margin-bottom: 30px;
    border: solid 1px #afaeae40;
    background: #f7f7f740;
    
    /*position: sticky;
    top: 0;*/
}

.email-tools{
  padding: 7px 0;
}
.email-tools input{
  padding: 3px;
    height: 26px;
    margin: 0 7px; 
    line-height: 18px;
}

.a-box {
  display: inline-block;
  /* //height: 5rem;
  //width: 5rem; */
  border: 2px solid blue;
  position: relative;
  z-index: 9999;
}
.archives{
    padding: 1em 1em 1em 1em;
    margin-bottom: 0px;
    margin-right: 16px;
}

</style>